'use client';

import { CustomEventName, GTMEventKey } from '@/utils/gtm';
import { QuotesCodeMapping } from '@/constants/quote/quote';
import { TrendChart } from '@/components/molecules/TrendChart';
import { TrendChartSkeleton } from '@/components/molecules/TrendChart/Skeleton';
import { useQuery } from '@tanstack/react-query';
import { getChartsHistories } from './getChartsHistories';
import Skeleton from './Skeleton';

const MINS_15 = 60000 * 15;

const Empty = () => (
  <div className='h-[167px] w-[188px]'>
    <TrendChartSkeleton />
  </div>
);

const ChartQClient = () => {
  const { data: items } = useQuery({
    queryKey: ['hotforex-histories'],
    queryFn: getChartsHistories,
    placeholderData: prev => prev,
    refetchInterval: MINS_15,
    refetchOnWindowFocus: false
  });

  if (!items) return <Skeleton />;

  return (
    <div className='flex items-center gap-[6px] overflow-scroll px-5 py-4 pb-6 pt-4'>
      {items?.map(({ data }) => {
        const symbol = data?.quote?.[QuotesCodeMapping.SYMBOL];
        const name = data?.quote?.[QuotesCodeMapping.CHINESE_NAME];
        const gtmEvent = {
          [GTMEventKey.EVENT_NAME]: CustomEventName.CLICK_FOREX,
          [GTMEventKey.SECTION]: '%p_熱門外匯',
          [GTMEventKey.CLICK_ITEM]: `${symbol}_${name}`
        };

        return (
          <div className='w-[188px]' key={symbol}>
            {data ? <TrendChart data={data} gtmEvent={gtmEvent} /> : <Empty />}
          </div>
        );
      })}
    </div>
  );
};

export default ChartQClient;
